import catalogPlugin from '@backstage/plugin-catalog/alpha';
import {
  PageBlueprint,
  coreExtensionData,
  createExtensionInput,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import type { CatalogTableColumnsFunc } from '@backstage/plugin-catalog';
import React from 'react';

// Alias para o route ref do catálogo (catalog.catalogIndex), preservando a
// navegação e os links internos ao substituir a página padrão.
const catalogIndexRouteRef = createRouteRef({ aliasFor: 'catalog.catalogIndex' });

// Sobrescreve a extensão `page:catalog` (sem `name`, para que o id coincida com
// o da página padrão e o `withOverrides` de fato a substitua). Mantemos o input
// `filters` para que as extensões de filtro (kind/type/tag/...) continuem
// anexadas e renderizadas.
const catalogPageOverride = PageBlueprint.makeWithOverrides({
  inputs: {
    filters: createExtensionInput([coreExtensionData.reactElement]),
  },
  factory(originalFactory, { inputs }) {
    return originalFactory({
      path: '/catalog',
      routeRef: catalogIndexRouteRef,
      loader: async () => {
        const { CatalogIndexPage, CatalogTable } = await import('@backstage/plugin-catalog');
        const filters = inputs.filters.map(filter =>
          filter.get(coreExtensionData.reactElement),
        );
        const columns: CatalogTableColumnsFunc = context => [
          ...CatalogTable.defaultColumnsFunc(context),
          {
            title: 'Fornecedor',
            highlight: false,
            width: 'auto',
            render: row =>
              row.entity.metadata.annotations?.['myralis.com.br/vendor'] ?? '—',
          },
          {
            title: 'Localização',
            highlight: false,
            width: 'auto',
            render: row =>
              row.entity.metadata.annotations?.['myralis.com.br/location'] ?? '—',
          },
          {
            title: 'GAMP 5',
            highlight: false,
            width: 'auto',
            render: row =>
              row.entity.metadata.annotations?.['myralis.com.br/gamp5-category'] ?? '—',
          },
        ];
        return React.createElement(CatalogIndexPage, {
          columns,
          filters: React.createElement(React.Fragment, null, ...filters),
        });
      },
    });
  },
});

export const customCatalogPlugin = catalogPlugin.withOverrides({
  extensions: [catalogPageOverride],
});
